import { Box, Typography } from "@mui/material";
import Layout from "components/structure/Layout";
import React, { useEffect, useState } from "react";
import ReportService from "services/ReportService";

const Agri360UserReport = () => {
  const [data, setData] = useState([]) 
   const [height, setHeight] = useState('800px');
  useEffect(() => {
    const fetchModules = async () => {
      try {
        const response = await ReportService.getReport("Other");  
        const activeCropList = response?.data?.response
        setData(getAgri360UserReport(activeCropList));
      } catch (error) {
        console.error("Error fetching the report:", error);
      }
    }
    fetchModules()
  }, [])

  const getAgri360UserReport = (reports) => {
    return reports.find(
      (report) => report.reportName === "Agri360 User Report"
    );
  };



  return (
    <Layout title={'Agri360 ESG Portal'} style={{ marginBottom: "100px", marginTop: "64px" }}>
    <Box>
    </Box>
    <Box sx={{mt:2}}>
    <iframe title="Farmer"
              width="100%"
              height={height}
              scrolling='no'
              frameBorder='0'
              src={`https://app.powerbi.com/reportEmbed?reportId=${data?.reportType}&autoAuth=true`}
              frameborder="0"
              allowFullScreen="true">
            </iframe>
    </Box>
    </Layout>
   
  );
};

export default Agri360UserReport;
